import { startCase } from 'lodash';
import { resolveResourceUrl } from './resolve-resource-url';
import { removeFilenameFromUrl } from './remove-filename-from-url';

export const setResourceUrl = (name, host, mainFileName) => {
	window[`__staticResourceUrl${startCase(name)}`] = removeFilenameFromUrl(resolveResourceUrl(host, mainFileName));
};
